// extracted by mini-css-extract-plugin
export default {"app":"Header_app__ottzq"};